/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-undef */
/* eslint-disable unicorn/no-array-for-each */
/* eslint-disable no-useless-escape */
/* eslint-disable unicorn/better-regex */
/* eslint-disable prettier/prettier */
import formValidation from 'formvalidation/core/Core';
import Message from 'formvalidation/plugins/Message';
import Trigger from 'formvalidation/plugins/Trigger';
import SubmitButton from 'formvalidation/plugins/SubmitButton';
import SelectorEngine from '../../utils/dom/selector-engine';
import dataLayer from '../../utils/data-layer';
import EventHandler from '../../utils/dom/event-handler';

import Request from '../../utils/Request';
import SnackbarNotification from '../../components/SnackbarNotification';
// eslint-disable-next-line no-unused-vars
import { scrollToElement, scrollToTop, scrollToNode, getDataFromForm } from '../../utils/misc';

import ValidationUtils from '../../utils/validation';
import Manipulator from '../../utils/dom/manipulator';
import { deleteCookie } from '../../utils/cookies';
import { PASSWORD_REGEX } from '../../utils/form-validation';
import { ClassNames } from './../../utils/dom/css-classes';

class CreateAccount {
	constructor() {
		this._accountWrapper = undefined;
		this._emailWrapper = undefined;
		//Scala Integration: By default we are setting the value as false as we will need to update it to true only after reading the alert updated by user.
		this.ltlAgeValidationAlertRead = false;
		this.emailAlreadyExists = false;
		this.errorWithEmailCheck = false;
		this.emailExistsErrorMessage = '';
		this.isEmailCheckInProgress = false;
		this.lastCheckedEmail = '';
		this.pendingSubmit = false; // tracking whether user tried to submit during email check
		this.initiateValidation();
	}

	initiateValidation() {
		this._accountWrapper = document.querySelector('.lta-account-registration');
		this._emailWrapper = document.querySelector('.p-email-confirmation');
		if (this._accountWrapper && this._emailWrapper) {
			const registerAccountForm = this._accountWrapper.querySelector('#accountRegister');
			const errorWrapper = this._accountWrapper.querySelector('.lta-account-registartion--error');
			const errorDefault = this._accountWrapper.querySelector('.lta-account-registartion--error-default');
			const errorLtlAgeValidation = this._accountWrapper.querySelector('.lta-account-registartion--error-ltl-age-validation');
			const errorTitleLTLAgeValidationis = this._accountWrapper.querySelector('.lta-account-registartion--error-ltl-age-validation').getAttribute('data-title') || '';
			const errorMessageLTLAgeValidation = this._accountWrapper.querySelector('.lta-account-registartion--error-ltl-age-validation').getAttribute('data-error-message') || '';
			const emailErrorWrapper = this._emailWrapper.querySelector('.p-email-confirmation--error');
			const dateComponent = SelectorEngine.findOne('#dob', this._accountWrapper);
			this.dayInput = this._accountWrapper.querySelector('#TextInputDay');
			this.monthInput = this._accountWrapper.querySelector('#TextInputMonth');
			this.yearInput = this._accountWrapper.querySelector('#TextInputYear');
			this.under13ErrorMessage = Manipulator.getDataAttribute(dateComponent, 'ageBelowThirteenErrorMessage');
			this.under18InfoBox = this._accountWrapper.querySelector('.lta-account-registartion--dob-under-18-age-info');

			// Email uniqueness check
			const emailInput = this._accountWrapper.querySelector('#email');
			this.emailExistsErrorMessage = Manipulator.getDataAttribute(registerAccountForm, 'email-exist-error-message');
			this.emailCheckApiFailedErrorMessage = Manipulator.getDataAttribute(registerAccountForm, 'email-check-api-fail-error-message');
			this.isEmailValid = false

			if (emailInput) {
				// Wrapping the input in a relative container if not already
				const wrapper = document.createElement('div');
				wrapper.classList.add('input-with-loader');
				emailInput.parentNode.insertBefore(wrapper, emailInput);
				wrapper.appendChild(emailInput);

				// Creating loader inside wrapper
				const loader = document.createElement('span');
				loader.className = 'lta-field-loader';
				wrapper.appendChild(loader);

				emailInput.addEventListener('blur', async (event) => {
					if (this.isEmailCheckInProgress) return;
					const email = event.target.value.trim();
					if (!email) return;

					const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
					if (!emailRegex.test(email)) {
						this.fv.updateFieldStatus('emailAddress', 'Invalid', 'regexp');
						const parentWrapper = emailInput.closest('.lta-text-input__wrapper');
						if (parentWrapper) parentWrapper.classList.add('is-invalid', 'is-focused');
						this.isEmailValid = false;
						this.isEmailCheckInProgress = false;
						return;
					}

					this.isEmailValid = false;
					this.isEmailCheckInProgress = true;
					this.emailAlreadyExists = false;
					this.emailExistsErrorMessage = '';
					loader.style.display = 'inline-block';
					emailInput.style.pointerEvents = 'none';
					this.fv.updateFieldStatus('emailAddress', 'Valid');

					const emailCheckApiUrl = Manipulator.getDataAttribute(registerAccountForm, 'email-check-api-url');
					try {
						const response = await Request.post(emailCheckApiUrl, { emailId: email });
						loader.style.display = 'none';
						emailInput.style.pointerEvents = '';
						this.isEmailCheckInProgress = false;

						const { accountExists, statusCode } = response;

						if (accountExists) {
							this.emailAlreadyExists = true;
							this.isEmailValid = false;
							this.fv.updateFieldStatus('emailAddress', 'Invalid', 'emailExists');
							const parentWrapper = emailInput.closest('.lta-text-input__wrapper');
							if (parentWrapper) parentWrapper.classList.add('is-invalid', 'is-focused');
							return;
						}

						if (!accountExists && statusCode == "99") {
							this.errorWithEmailCheck = true;
							this.emailExistsErrorMessage = 'Unable to verify your email, please try again later.';
							this.isEmailValid = false;
							this.fv.updateFieldStatus('emailAddress', 'Invalid', 'errorCheckingEmail');
							const parentWrapper = emailInput.closest('.lta-text-input__wrapper');
							if (parentWrapper) parentWrapper.classList.add('is-invalid', 'is-focused');
							return;
						}

						this.isEmailValid = true;
						this.emailAlreadyExists = false;
						this.errorWithEmailCheck = false;
						this.emailExistsErrorMessage = '';
						this.lastCheckedEmail = email;
						this.fv.updateFieldStatus('emailAddress', 'Valid');
						const parentWrapper = emailInput.closest('.lta-text-input__wrapper');
						if (parentWrapper) parentWrapper.classList.remove('is-invalid', 'is-focused');
					} catch (err) {
						console.error('Email check API error:', err);
						loader.style.display = 'none';
						emailInput.style.pointerEvents = '';
						this.isEmailValid = false;
						this.isEmailCheckInProgress = false;
					}
				});
			}

			this.strictMinAge = Manipulator.getDataAttribute(dateComponent, 'strictMinAge') || 4;
			this.minAge = Manipulator.getDataAttribute(dateComponent, 'minAge');
			this.minAgeErrorMessage = Manipulator.getDataAttribute(dateComponent, 'minAgeErrorMessage');
			this.ageStrictCheck = Manipulator.getDataAttribute(dateComponent, 'strictCheck');
			const errorFieldsContainer = this._accountWrapper.querySelector('.lta-account-registartion--fields-error');
			const emailAction = this._emailWrapper.querySelector('.js-resend-email');
			const resendEmailNotificationWrapper = SelectorEngine.findOne('.js-notification', this._emailWrapper);
			const captchaEnabled = SelectorEngine.findOne('#google_recaptcha')
			this.birthDateSelector = SelectorEngine.findOne('.lta-account-registartion--dob', this._element);
			
			this.registerAccountForm = registerAccountForm;
			this.errorWrapper = errorWrapper;
			this.errorDefault = errorDefault;
			this.errorLtlAgeValidation = errorLtlAgeValidation;
			this.emailResendBtn = emailAction;
			this.emailErrorWrapper = emailErrorWrapper;
			this.resendEmailNotificationWrapper = resendEmailNotificationWrapper;

			this.formSubmitBtn = this.registerAccountForm.querySelector('.js-create-submit');

			const resendEmailNotification = new SnackbarNotification(resendEmailNotificationWrapper, {});

			const errorDismissCta = this._accountWrapper.querySelector('.js-dismiss-account-error');
			errorDismissCta.addEventListener('click', () => {
				errorWrapper.classList.add('u-hidden');
			});

			const errorDefaultDismissCta = this._accountWrapper.querySelector('.js-dismiss-account-error-default');
			errorDefaultDismissCta.addEventListener('click', () => {
				this.formSubmitBtn.disabled = false;
				errorDefault.classList.add('u-hidden');
			});

			const errorltlAgeValidationDismissCta = this._accountWrapper.querySelector('.js-dismiss-account-error-ltl-age-validation');
			errorltlAgeValidationDismissCta.addEventListener('click', () => {
				errorLtlAgeValidation.classList.add('u-hidden');
				this.ltlAgeValidationAlertRead = true;
				registerAccountForm.querySelector('.js-create-submit').click();
			});


			const errorEmailDismissCta = emailErrorWrapper.querySelector('.js-dismiss-email-error');
			errorEmailDismissCta.addEventListener('click', () => {
				emailErrorWrapper.classList.add('u-hidden');
				emailAction.disabled = false;
			});

			const errorFieldsWrapper = errorFieldsContainer.querySelector('.lta-account-registartion--fields-container');
			const fieldsErrorsList = errorFieldsWrapper.querySelector('ul');
			fieldsErrorsList.textContent = '';

			if (registerAccountForm !== null) {
				this.fv = formValidation(registerAccountForm, {
					fields: {
						firstName: {
							validators: {
								notEmpty: {
									message: 'Please enter a first name'
								},
								stringLength: {
									min: 2,
									message: 'First name must be 2 or more letters'
								},
								regexp: {
									regexp: /^[a-zA-Z-' ]+$/,
									message: 'Please enter a first name that contains only letters'
								}
							}
						},
						lastName: {
							validators: {
								notEmpty: {
									message: 'Please enter a last name'
								},
								stringLength: {
									min: 2,
									message: 'Last name must be 2 or more letters'
								},
								regexp: {
									regexp: /^[a-zA-Z-' ]+$/,
									message: 'Please enter last name that contains only letters'
								}
							}
						},
						// dob: {
						// 	validators: {
						// 		splitDate: {
						// 			missingMessage: 'Please enter a date of birth',
						// 			invalidMessage: 'Please enter a valid date',
						// 			futureMessage: 'Please enter a date in the past',
						// 			message: `Members need to be over ${this.strictMinAge} years of age`,
						// 			maxAge: this.strictMinAge,
						// 			invalidDate: 'Please enter a valid date'
						// 		},
						// 		under13Error: {
						// 			message: `${under13ErrorMessage}`
						// 		}
						// 	}
						// },
						// Commented out the existing dob validation as part of Bug 33927, 
						// as we are adding a new custom validation method validateDob to have more control over the validation and error messages. 
						// We will remove the old validation once we are sure the new validation is working fine in production.
						dob: {
							validators: {
								callback: {
									message: 'Please enter a valid date',
									callback: (input) => {
										return this.validateDob();
									}
								}
							}
						},
						gender: {
							validators: {
								radioSelected: {
									message: 'Please choose a gender'
								}
							}
						},
						emailAddress: {
							validators: {
								notEmpty: {
									message: 'Please enter an email address'
								},
								emailExists: {
									message: `${this.emailExistsErrorMessage}`
								},
								errorCheckingEmail: {
									message: `${this.emailCheckApiFailedErrorMessage}`
								},
								regexp: {
									regexp:
										/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
									message: 'Please enter a valid email address'
								},
								callback: {
									message: `${
										this.emailAlreadyExists ? this.emailExistsErrorMessage : this.emailCheckApiFailedErrorMessage
									}`,
									callback: () => !this.emailAlreadyExists || !this.errorWithEmailCheck
								}
							}
						},
						username: {
							validators: {
								notEmpty: {
									message: 'Please enter a username'
								},
								stringLength: {
									min: 6,
									max: 19,
									message: 'Please choose a username that is longer than 6 and fewer than 19 characters'
								},
								regexp: {
									regexp: /^[\w\d_.-]+$/,
									message: 'Please choose a username that contains just letters and numbers'
								},
								different: {
									compare: () => '',
									message: 'This username has already been taken. Please choose another username'
								}
							}
						},
						password: {
							validators: {
								notEmpty: {
									message: 'Please enter a password'
								},
								regexp: {
									regexp: PASSWORD_REGEX,
									message: 'Please enter 8–25 characters with at least one upper case, one lower case, one number and one special character (!@#$%^&*()_+-=)'
								},
								different: {
									compare: () => registerAccountForm.querySelector('[name="username"]').value,
									message: 'Please create a password that is different to your username'
								}
							}
						}
					},
					plugins: {
						trigger: new Trigger(),
						submitButton: new SubmitButton(),
						message: new Message({
							clazz: 'lta-text-input__label-instruction',
							container: function (field, element) {
								const fieldType = element.getAttribute('type');
								const inputWrapper = element.closest(ValidationUtils.getFieldWrapper(fieldType));
								return inputWrapper.querySelector('.lta-text-input--error');
							}
						})
					}
				})
				EventHandler.on(registerAccountForm, 'submit', (e) => {
					const emailValue = emailInput.value.trim();

					if (emailValue && emailValue !== this.lastCheckedEmail) {
						e.preventDefault();
						this.pendingSubmit = true;
						emailInput.blur();
					}
				});
				this.fv
					.on('core.field.invalid', (name) => {
						const invalidField = document.getElementsByName(name)[0];
						const invalidFieldType = invalidField.getAttribute('type');
						const fieldWrapper = invalidField.closest(ValidationUtils.getFieldWrapper(invalidFieldType));
						fieldWrapper.classList.add(...ValidationUtils.getErrorClasses(invalidFieldType));
					})
					.on('core.field.valid', (name) => {
						const invalidField = document.getElementsByName(name)[0];
						const invalidFieldType = invalidField.getAttribute('type');
						const fieldWrapper = invalidField.closest(ValidationUtils.getFieldWrapper(invalidFieldType));
						fieldWrapper.classList.remove(...ValidationUtils.getErrorClasses(invalidFieldType));

						// remove error messages that are now valid
						const errorMessages = SelectorEngine.find(`.js-validation-${name}`, fieldsErrorsList);
						if (errorMessages) {
							[...errorMessages].forEach((element) => {
								element.remove();
							});
						}

						// if there are no more error messages, remove error messages container
						if (fieldsErrorsList.children.length === 0) {
							errorFieldsContainer.classList.add('u-hidden');
						}
					})
					.on('core.form.invalid', () => {
						errorFieldsContainer.classList.remove('u-hidden');
						errorFieldsContainer.scrollIntoView();
					})
					.on('core.form.validating', () => {
						fieldsErrorsList.textContent = '';
						this._dobTouched = true;
					})
					.on('plugins.message.displayed', (e) => {
						// checks if error message isn't already added
						if (!SelectorEngine.findOne(`.js-validation-${e.field}--${e.validator}`, fieldsErrorsList)) {
							const listItem = document.createElement('li');
							const listSpan = document.createElement('span');
							const listLink = document.createElement('a');
							listLink.setAttribute('href', '#');
							listItem.setAttribute('class', `js-validation-${e.field} js-validation-${e.field}--${e.validator}`);
							// Allowing HTML in message for under 13 error to accommodate the link to login page in the snackbar error message.
							// For other errors, the message is expected to be plain text.
							listLink.innerHTML = e.message;
							listSpan.append(listLink);
							listItem.append(listSpan);

							fieldsErrorsList.append(listItem);

							listLink.addEventListener('click', (event) => {
								event.preventDefault();
								scrollToNode(e.element);
								e.element.focus();
							});
						}
					})
					.on('core.form.valid', () => {
						const currentEmail = emailInput.value.trim();
						// If email changed and API not checked yet
						if (currentEmail && currentEmail !== this.lastCheckedEmail) {
							this.pendingSubmit = true;
							emailInput.blur(); // trigger API check
							return;
						}
						if (this.isEmailCheckInProgress) {
							this.pendingSubmit = true;
							const parentWrapper = emailInput.closest('.lta-text-input__wrapper');
							if (parentWrapper) {
								setTimeout(() => {
									parentWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
								}, 100);
							}
							return;
						}

						if (this._activeDobError === 'under13Error') {
							this.fv.updateFieldStatus('dob', 'Invalid', 'under13Error');
							const dobWrapperEl = this._accountWrapper.querySelector('.lta-account-registartion--dob');
							if (dobWrapperEl) {
								dobWrapperEl.classList.add('is-invalid', 'is-focused');
								setTimeout(() => {
									dobWrapperEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
									dobWrapperEl.querySelector('input')?.focus();
								}, 1000);
							}
							this.formSubmitBtn.disabled = false;
							return;
						}

						const scrollToEmailError = (wrapper) => {
							if (!wrapper) return;
							wrapper.classList.add('is-invalid', 'is-focused');
							setTimeout(() => {
								wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
								wrapper.querySelector('input')?.focus();
							}, 100);
						};

						if (!this.isEmailValid) {
							scrollToEmailError(emailInput.closest('.lta-text-input__wrapper'));
							this.formSubmitBtn.disabled = false;
							return;
						}

						if (this.emailAlreadyExists) {
							this.fv.updateFieldStatus('emailAddress', 'Invalid', 'emailExists');
							scrollToEmailError(emailInput.closest('.lta-text-input__wrapper'));
							this.formSubmitBtn.disabled = false;
							return;
						}

						if (this.errorWithEmailCheck) {
							this.fv.updateFieldStatus('emailAddress', 'Invalid', 'errorCheckingEmail');
							scrollToEmailError(emailInput.closest('.lta-text-input__wrapper'));
							this.formSubmitBtn.disabled = false;
							return;
						}

						errorFieldsContainer.classList.add('u-hidden');
						this.formSubmitBtn.disabled = true;

						let isGoogleCaptchaValid = this.getCaptchaResponse();
						const queryString = window.location.search;
						const urlParameters = new URLSearchParams(queryString);
						// Scala App Integration : As the Signup Button is called again post LTL Age Valitdation alert is provided and bypassed to proceed ahead. So Google captcha is disabled here.
						if (urlParameters.has('source') && urlParameters.get('source') === "ltl") {
							if (this.ltlAgeValidationAlertRead) {
								isGoogleCaptchaValid = true;
							}
						}

						if (isGoogleCaptchaValid) {
							const finalData = this.preparePayload();
							const [dd, mm, yy] = finalData.dob.split('/');

							// Scala App Integration : this variable is handled for validating date when Signup is being triggered from external Scala app and query parameter source = ltl has added.
							let isDateValidated = true;

							const dob = new Date(`${mm}/${dd}/${yy}`);
							const currentDate = new Date();

							const age = currentDate.getFullYear() - dob.getFullYear();
							if (age < this.minAge && !this.ltlAgeValidationAlertRead) {
								isDateValidated = false;
								const errorList = errorLtlAgeValidation.querySelector('ul');
								errorList.textContent = this.minAgeErrorMessage;
								errorLtlAgeValidation.classList.remove('u-hidden');
								errorLtlAgeValidation.scrollIntoView();
								this.formSubmitBtn.disabled = false;
							} else {
								this.ltlAgeValidationAlertRead = true;
							}
							if (isDateValidated && this.ltlAgeValidationAlertRead) {
								try { // Pushing event  to datalayer for tracking
									dataLayer.push({
										event: 'advantage_signup',
										Step_Completed: 'Advantage Details'
									});
								} catch (error) {
									console.log(error.message);
								}
								this.registerUser(finalData);
							} 
						} else {
							console.log({isGoogleCaptchaValid})
							this.invalidCaptcha();
						}
					}
				)
			}
			const dateFormInputs = SelectorEngine.find('input[type="number"]', this.birthDateSelector);
			for (const input of dateFormInputs) {
				EventHandler.on(input, 'blur', () => {
					setTimeout(() => {
						const activeElement = document.activeElement;
						const stillInside = this.birthDateSelector?.contains(activeElement);

						if (!stillInside) {
							// User has fully left DOB component
							this._dobTouched = true;
							this.fv.revalidateField('dob');
						}
					}, 0);
				});
			}
		}
		setTimeout(() => {
			this.resetCaptcha();
		}, 500);
	}

	showUnder18InfoBox() {
		this.under18InfoBox?.classList.remove(ClassNames.Hidden);
		this.under18InfoBox?.classList.add(ClassNames.FlexClass);
	}

	hideUnder18InfoBox() {
		this.under18InfoBox?.classList.add(ClassNames.Hidden);
		this.under18InfoBox?.classList.remove(ClassNames.FlexClass);
	}

	// For Bug 33927, we are adding a new custom validation method to have more control over the DOB validation and error messages as per different scenarios. 
	// We will remove the old validation method once we are sure the new one is working fine in production.
	validateDob() {
		const dayStr = this.dayInput?.value?.trim();
		const monthStr = this.monthInput?.value?.trim();
		const yearStr = this.yearInput?.value?.trim();

		const today = new Date();
		const strictMinAge = this.strictMinAge;
		const under13Message = this.under13ErrorMessage;

		const isEmpty = !dayStr && !monthStr && !yearStr;
		const isPartial = !dayStr || !monthStr || !yearStr || yearStr.length < 4;

		// If completely empty
		if (isEmpty) {
			this.hideUnder18InfoBox();

			if (!this._dobTouched) {
				return true; // still typing
			}

			return {
				valid: false,
				message: 'Please enter a date of birth'
			};
		}

		// If partially filled
		if (isPartial) {
			if (!this._dobTouched) {
				return true;
			}

			return {
				valid: false,
				message: 'Please enter a valid date'
			};
		}

		const day = parseInt(dayStr, 10);
		const month = parseInt(monthStr, 10);
		const year = parseInt(yearStr, 10);

		// Basic numeric validation
		if (
			Number.isNaN(day) ||
			Number.isNaN(month) ||
			Number.isNaN(year) ||
			year < 1900 ||
			year > today.getFullYear()
		) {
			return {
				valid: false,
				message: 'Please enter a valid date'
			};
		}

		// Create date
		const dob = new Date(year, month - 1, day);

		// Real calendar validation
		if (
			dob.getFullYear() !== year ||
			dob.getMonth() !== month - 1 ||
			dob.getDate() !== day
		) {
			return {
				valid: false,
				message: 'Please enter a valid date'
			};
		}

		// Future date
		if (dob > today) {
			return {
				valid: false,
				message: 'Please enter a date in the past'
			};
		}

		// Calculate age
		let age = today.getFullYear() - year;
		const hasBirthdayPassed =
			today.getMonth() > month - 1 ||
			(today.getMonth() === month - 1 && today.getDate() >= day);

		if (!hasBirthdayPassed) age--;

		// Age < strict minimum
		if (age < strictMinAge) {
			this.hideUnder18InfoBox();
			return {
				valid: false,
				message: `Members need to be over ${strictMinAge} years of age`
			};
		}

		// Age 4–12
		if (age >= strictMinAge && age < 13) {
			this.hideUnder18InfoBox();
			return {
				valid: false,
				message: under13Message
			};
		}

		// Age 13–17
		if (age >= 13 && age < 18) {
			this.showUnder18InfoBox();
		} else {
			this.hideUnder18InfoBox();
		}

		return true;
	}

	preparePayload() {
		const urlParameters = new URLSearchParams(window.location.search);
		const dataObject = getDataFromForm(this.registerAccountForm);
		const dobBits = dataObject.dob.split('-');
		const newDataObject = {
			...dataObject,
			dob: `${dobBits[2]}/${dobBits[1]}/${dobBits[0]}`,
			marketingConsent: dataObject.marketingConsent || 'No',
			offerConsent: dataObject.offerConsent || 'No',
			termsAndConditionConsent: 'Yes',
			returnUrl: urlParameters.get('redirect_uri')
		};
		return newDataObject;
	}

	async registerUser(data) {
		let response;
		try {
			const apiResponse = await Request.post(this.registerAccountForm.dataset.url, data);
			this.resetCaptcha();
			this.formSubmitBtn.disabled = false;
			if (!apiResponse.Success) {
				response = apiResponse.AccountRegistryResponse.response;
				if (response === 'Username exists' || response === 'ACCOUNT_ALREADY_EXISTS') {
					fv.updateValidatorOption('username', 'different', 'compare', () => finalData.username).updateFieldStatus('username', 'Invalid', 'different');
					scrollToElement('[name="emailAddress"]');
				} else {
					this.showRegistrationError(response);
				}
				this.ltlAgeValidationAlertRead = false;
			} else {
				// Delete the cookie if it exists
				deleteCookie('sso-checkout-signup-rtn');
				const registerForm = document.querySelector('.lta-account-registration');
				const emailConfirm = document.querySelector('.p-email-confirmation');
				registerForm.classList.add('u-hidden');
				emailConfirm.classList.remove('u-hidden');
				emailConfirm.scrollIntoView();
				this.ltlAgeValidationAlertRead = false;
				try { // Pushing event  to datalayer for tracking
					dataLayer.push({
						event: 'advantage_signup',
						Step_Completed: 'Advantage Unverified',
						primaryRole: data.primaryRole ? data.primaryRole : 'General'
					});
				} catch (error) {
					console.log(error.message);
				}
			}	
			this.emailResendBtn.addEventListener('click', () => {
				this.resendEmailHandler();
			});
		} catch(error) {
			console.error(error);
			
			const errorListItem = SelectorEngine.findOne('ul li span', this.errorDefault);
			let errorMessage = 'Please try again in 10 minutes.';
			
			// Handle different types of network errors
			if (error.name === 'TypeError') {
				if (error.message && error.message.toLowerCase().includes('failed to fetch')) {
					errorMessage = 'Unable to connect to the server. Please check your internet connection and try again.';
				} else if (error.message && error.message.toLowerCase().includes('network')) {
					errorMessage = 'Network error occurred. Please check your internet connection and try again.';
				} else {
					errorMessage = 'Request timed out. Please check your internet connection and try again.';
				}
			} else if (error.name === 'AbortError') {
				errorMessage = 'Request was cancelled. Please try again.';
			} else if (error.message) {
				// Check for specific error messages
				if (error.message.toLowerCase().includes('timeout')) {
					errorMessage = 'Request timed out. Please try again.';
				} else if (error.message.toLowerCase().includes('network')) {
					errorMessage = 'Network error occurred. Please check your internet connection and try again.';
				} else if (error.message.toLowerCase().includes('fetch')) {
					errorMessage = 'Failed to connect to the server. Please try again.';
				} else {
					errorMessage = error.message;
				}
			}
			
			errorListItem.innerHTML = errorMessage;
			
			this.errorDefault.classList.remove('u-hidden');
			this.errorDefault.scrollIntoView();
		}
		return response;
	}

	async resendEmailHandler() {
		const usernameValue = this.registerAccountForm.querySelector('[name="username"]').value;
		this.emailResendBtn.disabled = true;

		const resendEmail = await Request.post('/api/AccountRegisterApi/ResendEmailVerification', { username: usernameValue })
			.catch((error) => {
				console.error('Resend email error:', error);
				
				// Update error message based on the type of error
				const emailErrorMessage = this.emailErrorWrapper.querySelector('.title');
				const emailErrorList = this.emailErrorWrapper.querySelector('ul li span');
				
				if (emailErrorMessage && emailErrorList) {
					let errorMessage = 'Failed to resend verification email. Please try again.';
					
					if (error.name === 'TypeError' && error.message && error.message.toLowerCase().includes('failed to fetch')) {
						errorMessage = 'Unable to connect to the server. Please check your internet connection and try again.';
					} else if (error.message && error.message.toLowerCase().includes('network')) {
						errorMessage = 'Network error occurred. Please check your internet connection and try again.';
					} else if (error.message && error.message.toLowerCase().includes('timeout')) {
						errorMessage = 'Request timed out. Please try again.';
					}
					
					emailErrorList.innerHTML = errorMessage;
				}
				
				this.emailErrorWrapper.classList.remove('u-hidden');
				this.emailErrorWrapper.scrollIntoView();
			});

		if (resendEmail?.Success) {
			this.resendEmailNotificationWrapper.open();
			this.emailResendBtn.disabled = false;
		} else {
			this.emailErrorWrapper.classList.remove('u-hidden');
			this.emailErrorWrapper.scrollIntoView();
		}
	}

	showRegistrationError(response) {
		const errorMessage = this.errorDefault.querySelector('.title');
		const errorList = this.errorDefault.querySelector('ul');

		const responseParts = response?.split(/\n/).filter(item => !!item) || [];
		const errorTitle = responseParts.shift();
		errorMessage.innerHTML = errorTitle;
		errorList.textContent = '';
		
		if (responseParts.length > 0) {
			responseParts.forEach((part) => {
				const liElement = document.createElement('li');
				const spanElement = document.createElement('span');
				spanElement.textContent = part;
				liElement.append(spanElement);
				errorList.append(liElement);
			})
		}
		
		this.errorDefault.classList.remove('u-hidden');
		this.errorDefault.scrollIntoView();
	}

	invalidCaptcha() {
		const errorList = this.errorDefault.querySelector('ul');
		errorList.textContent = 'Captcha is invalid. Please validate.';
		this.errorDefault.classList.remove('u-hidden');
		this.errorDefault.scrollIntoView();
		this.formSubmitBtn.disabled = false;
		this.ltlAgeValidationAlertRead = false;
	}

	resetCaptcha() {
		if(SelectorEngine.findOne('#google_recaptcha')) {
			grecaptcha.reset();
		}
	}

	getCaptchaResponse() {
		let isValid = false;
		if (SelectorEngine.findOne('#google_recaptcha')) {
			try {
				const captchaResponse = grecaptcha?.getResponse();
				if (captchaResponse.length > 0) {
					isValid = true;
				} else {
					isValid = false;
				}
			} catch (error) {
				isValid = true;
				console.error(error);
			}
		} else {
			isValid = true;
		}
		return isValid;
	}
}

const globalCreateAccount = new CreateAccount();

export default globalCreateAccount;
